import classNames from '@/lib/classNames';
import { type VariantProps, cva } from 'class-variance-authority';

const containerVariants = cva('box-content mx-auto', {
    variants: {
        maxWidth: {
            md: 'max-w-md',
            lg: 'max-w-lg',
            xl: 'max-w-xl',
        },
        paddingX: {
            true: 'px-4 md:px-8',
        },
        bg: {
            sand: 'bg-sand',
            shell: 'bg-shell-25',
        },
        rounded: {
            true: 'rounded-3xl',
        },
    },
    compoundVariants: [
        { bg: 'sand', class: 'py-8 lg:py-20' },
        { bg: 'shell', class: 'py-8 lg:py-20' },
    ],
    defaultVariants: {
        maxWidth: 'lg',
        paddingX: true,
    },
});

interface ContainerProps extends VariantProps<typeof containerVariants> {
    className?: string;
    wrapperClassName?: string;
    children: React.ReactNode;
    paddingX?: boolean;
}

const ConditionalContainerWrapper = ({
    condition,
    className,
    children,
}: {
    condition: boolean;
} & ContainerProps) => (condition ? <div className={className}>{children}</div> : <>{children}</>);

export default function Container({ bg, rounded, paddingX, maxWidth, className, wrapperClassName, children }: ContainerProps) {
    return (
        <ConditionalContainerWrapper condition={Boolean(bg)} className={classNames(containerVariants())}>
            <ConditionalContainerWrapper
                condition={Boolean(bg)}
                className={classNames(
                    containerVariants({
                        bg,
                        rounded,
                        className: wrapperClassName,
                    })
                )}
            >
                <div
                    className={classNames(
                        containerVariants({
                            paddingX: bg ? false : paddingX !== undefined ? paddingX : true,
                            maxWidth: bg ? 'md' : maxWidth !== undefined ? maxWidth : 'lg',
                            className,
                        })
                    )}
                >
                    {children}
                </div>
            </ConditionalContainerWrapper>
        </ConditionalContainerWrapper>
    );
}
